<template>
  <invoice-application-preview :is-edit-page="true"/>
</template>
<script>
  import InvoiceApplicationPreview from "./InvoiceApplicationPreview.vue";
  export default {
    name: "InvoiceApplicationEdit",
    components: {
      InvoiceApplicationPreview,
    },
  };
</script>